export default __webpack_public_path__ + "static/media/maintenance.826df857.svg";